import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import { ShipperDetails } from "../components";
import styles from "./styles";

const localStyles = (theme) => ({
  specilInstruction: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 4,
    padding: "8px 16px",
    marginTop: 12,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    lineHeight: "16px",
    color: theme.dispatchPanelLabelValueColor,
    height: 56,
    overflowY: "auto",
  },
  pickupNumberTitle: {
    marginRight: 10,
  },
});

const LeftInfoPanel = (props) => {
  const { classes, pickupInfo, hidePickupNumber } = props;
  return (
    <Grid container spacing={24}>
      {!hidePickupNumber ? (
        <Grid item xs={12}>
          <Grid container className={classes.row}>
            <div
              className={`${classes.sectionTitle} ${classes.pickupNumberTitle}`}
            >
              Pickup #:
            </div>
            <div className={classes.sectionInfo}>{pickupInfo.pickupNumber}</div>
          </Grid>
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <div className={classes.sectionTitle}>Shipper Details</div>
        <ShipperDetails data={pickupInfo} />
      </Grid>
      <Grid item xs={12}>
        <div className={classes.sectionTitle}>Special Instructions</div>
        <div className={`${classes.specilInstruction} customScroll`}>
          {pickupInfo.specialInstructions}
        </div>
      </Grid>
    </Grid>
  );
};
export default withStyles((theme) => ({
  ...styles(theme),
  ...localStyles(theme),
}))(LeftInfoPanel);
